
import { ColumnDef } from "@tanstack/react-table"
import React from "react"
import { ComponentColumnDefinition, TableRowData } from "../../../../../../state/listing/generic-listing/column-definitions"
import { getValueFromObject } from "../../../../../../utils/object"

export default (columnDefinition: ComponentColumnDefinition): Partial<ColumnDef<TableRowData>> => ({
    cell: info => {
        const buildProps = (columnDefProps : {[key: string]: string}): {[key: string]: string} => {
            const props = {}
            for (const prop in columnDefProps) {
                // case when we pass a whole row object as props
                if (columnDefProps[prop] == "original") {
                    props[prop] = info.row.original
                    continue
                }
                
                if (columnDefProps[prop] == "filters"){
                    props[prop] = info.table.options.meta?.filters
                    continue
                }

                props[prop] = getValueFromObject(info.row.original, columnDefProps[prop])
            }
            return props
        }

        const Component = columnDefinition.dataAttributes?.component
        if (!Component) return "-"

        const props = columnDefinition.dataAttributes?.props ? buildProps(columnDefinition.dataAttributes?.props) : {}
        return <Component {...props} />
    }
})


// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/listing-table/mappers/cell-mappers/ComponentCellMapper.tsx